import { Trash2, Eye, EyeOff } from "lucide-react";

/** Inline editor for the selected audio clip: volume, fades, delete. */
export default function ClipInspector({ clip, trackId, onChange, onRemove }) {
  if (!clip) return null;
  const num = (field) => (e) => onChange(trackId, clip.id, { [field]: parseFloat(e.target.value) || 0 }, true);
  return (
    <div className="flex items-center gap-3 px-3 py-2 rounded-lg bg-white/5 border border-white/10 text-[11px] text-white/70">
      <span className="font-semibold text-white truncate max-w-[20%]">{clip.label || clip.group_key || "clip"}</span>
      <span className="font-mono text-white/40">@{(clip.start ?? 0).toFixed(2)}s · {(clip.duration ?? 0).toFixed(2)}s</span>
      <label className="flex items-center gap-1">vol
        <input type="range" min={0} max={1.5} step={0.05} value={clip.gain ?? 1}
          onChange={(e) => onChange(trackId, clip.id, { gain: parseFloat(e.target.value) }, true)}
          className="w-24 accent-[var(--color-gold-500)]" />
        <span className="w-6">{Math.round((clip.gain ?? 1) * 100)}</span>
      </label>
      <label className="flex items-center gap-1">fade in
        <input type="number" min={0} max={5} step={0.1} value={clip.fade_in ?? 0} onChange={num("fade_in")}
          className="w-12 bg-black/40 border border-white/10 rounded px-1 py-0.5" />
      </label>
      <label className="flex items-center gap-1">fade out
        <input type="number" min={0} max={5} step={0.1} value={clip.fade_out ?? 0} onChange={num("fade_out")}
          className="w-12 bg-black/40 border border-white/10 rounded px-1 py-0.5" />
      </label>
      <button onClick={() => onChange(trackId, clip.id, { disabled: !clip.disabled }, true)} className={`ml-auto ${clip.disabled ? "text-white/30" : "text-white/60 hover:text-white"}`} title={clip.disabled ? "Enable clip" : "Mute / disable clip"}>{clip.disabled ? <EyeOff size={13} /> : <Eye size={13} />}</button>
      <button onClick={() => onRemove(trackId, clip.id)} className="text-white/50 hover:text-red-400" title="Delete clip"><Trash2 size={13} /></button>
    </div>
  );
}
